export const setUserSession = (user) => {
  const session_data = user != null ? JSON.stringify(user) : null
  return localStorage.setItem('yid_user', session_data)
}